import { window } from 'd3';
import React, { FunctionComponent, useState, useEffect, Fragment } from 'react';
import { Accordion, Nav, Row, Col, Image, Button } from 'react-bootstrap';
import ficha_user from '../../assets/img/pastilla2.png';
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
//import SupportModal from '../Modals/supportModal';

const PlansBanner:FunctionComponent<{}> = () => {

  const [showBannerOrSupportButton, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [activedSupport, setActivedSupport] = useState(false);

  const checkForActivedSupport = async () => {
    try {
      const actived = (await ObexRequestHandler.get('/active_support_plan')).data;
      setActivedSupport(actived);
      if (actived) {
        const supportScript = document.getElementById('ze-snippet') as HTMLScriptElement;

        if (!supportScript) { // si no existe el script
          const script = document.createElement('script');

          script.id = 'ze-snippet';
          script.src = 'https://static.zdassets.com/ekr/snippet.js?key=1d42ba61-1ecd-4371-bea3-6891df9e5892';
          script.async = true;
        
          document.body.appendChild(script);
        }
      }
      setShow(true);
    } catch (error) {
      console.error('ERROR GETTING ACTIVED SUPPORT ', error);
    }
  }

  useEffect(() => {
    //checkForActivedSupport();  
    return () => {
      try {        
        //const supportScript = document.getElementById('ze-snippet') as HTMLScriptElement;
        //supportScript.parentElement.removeChild(supportScript);
        //const supportButton = document.getElementById('launcher') as HTMLIFrameElement;
        //supportButton.parentElement.removeChild(supportButton);
      } catch (error) {
        console.error('error removing support button')
      }
    }
  }, []);


  return (
    <Fragment >
      { (true) &&
        <Fragment>
          <div className="box-support mt-auto text-center " style={{position: 'fixed', bottom: 0, width: '289px', marginLeft:'-24px' }} >
            <Col md="5" className="my-3 mx-auto">
              <Image src={ficha_user}  fluid/>
            </Col>
            <Col md="12" className="title-box mb-3">
              <span>101OBeX<br></br></span>
              <span>Register Now</span>
            </Col>
            <Col md="12" className="text-box mb-3">
              <span>Get your plan.</span>
            </Col>
            <Col md="12" className="mb-3">
              <Button className="obex-btn btn-green" href="https://www.101obex.com/pricing">see Plans</Button>
            </Col> 
          </div>

        </Fragment>
      }
    </Fragment>
    
  )
};

export default PlansBanner;